import axios from 'axios';
import { logout } from '../auth/auth';

const api = axios.create({
  baseURL: 'https://apis.calltify.in', // Update with your backend URL
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      logout(); // clears token + redirects
    }
    return Promise.reject(error);
  }
);

export const agentServiceApi = axios.create({
  baseURL: 'https://apis.calltify.in/api/v1',
  headers: { 'Content-Type': 'application/json' }
});

agentServiceApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

agentServiceApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      logout();
    }
    return Promise.reject(error);
  }
);

export default api;
